// ${
//   pageErrorCase === "notSetConfig" ||
//   pageErrorCase === "notRequestedWanted"
//     ? `btn_warningMessage btn_warningMessage--${pageErrorCase}`
//     : isRosterCreating
//       ? `button--createRoster--disabled`
//       : ""
// }`

// pageErrorCase === "notSetConfig" ||
//   pageErrorCase === "notRequestedWanted" ||
//   isRosterCreating ||
//   !!isAdmin;
import { images } from "@img/imagesMap";

type BtnCreateRosterProps = {
  onClick: () => void;
  disabled?: boolean;
  isCreating?: boolean;
  pageErrorCase?:
    | "notSetConfig"
    | "notRequestedWanted"
    | "emtpyRoster"
    | "prepared"
    | null;
};

export default function BtnCreateRoster({
  onClick,
  disabled = false,
  isCreating = false,
  pageErrorCase = null,
}: BtnCreateRosterProps) {
  const hasWarning =
    pageErrorCase === "notSetConfig" || pageErrorCase === "notRequestedWanted";

  return (
    <div
      className={`bg-sig-gradient rounded-full p-[3px] group 
        ${isCreating ? "button--createRoster--disabled" : ""}
        ${hasWarning ? `btn_warningMessage btn_warningMessage--${pageErrorCase}` : ""}`}
    >
      <button
        type="button"
        className="rounded-full py-2.5 px-7 bg-white flex items-center gap-4 group-hover:bg-transparent transition-all duration-300"
        disabled={disabled}
        onClick={onClick}
      >
        <img
          src={images.logo_svg}
          alt=""
          className="button_aideLogo group-hover:brightness-0 group-hover:invert transition-all duration-300"
          style={{ height: "1em" }}
        />
        <span className="font-pretendard group-hover:text-white transition-colors duration-300">
          근무표 생성
        </span>
      </button>
    </div>
  );
}
